import React, { useEffect } from "react";
import BookmarkIcon from "@mui/icons-material/Bookmark";
// import { Avatar } from "@mui/material";
import img from '../../assets/image/Background-Photo.png'
// import profile from '../../assets/image/Player.jpg'
import { Link } from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAppDispatch, useAppSelector } from "../../useStore";
import { applicantDashboardData } from "../../features/Applicant/applicantSlice";


function SideBar() {
  const dispatch = useAppDispatch();
  // @ts-ignore
  const userInfo = JSON.parse(localStorage.getItem("user_ats"));
  const { applicantDashboardDatadata: data } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    dispatch(applicantDashboardData())
  }, [dispatch]);

  const screening = data?.data?.screenedApplications;
  const applicant = data?.data?.pendingApplications;// Objects with application status "APPLIED"
  const offered = data?.data?.offeredApplications; // Objects with application status "OFFERED"
  const hired = data?.data?.hiredApplications; // Objects with application status "HIRED"
  const dropout = data?.data?.droppedApplications; // Objects with application status "DROPOUT" 
  const evaluation = data?.data?.evaluatedApplications; // Objects with application status "EVALUATION"
  const interview = data?.data?.pendingInterviews;

  const ApplicantLink = [
    {
      Active: "New",
      link: "/newapplicants",
      suffix: applicant
    },
    {
      Active: "Screening",
      link: "/applicantscreening",
      suffix: screening
    },
    {
      Active: "Evaluating",
      link: "/applicantevaluation",
      suffix: evaluation
    },
    {
      Active: "Offered",
      link: "/applicantoffered",
      suffix: offered
    },
    {
      Active: "interview",
      link: "/applicantinterview",
      suffix: interview
    },
    {
      Active: "Hired",
      link: "/applicanthired",
      suffix: hired
    },
    {
      Active: "Dropouts",
      link: "/applicantdrafts",
      suffix: dropout
    },
  ]
  const locale = 'en';
  const [today] = React.useState(new Date()); // Save the current date to be able to trigger an update 
  const date = `${today.toLocaleDateString(locale, { month: 'long' })}\n\n`;

  return (
    <div className="sidebar">
      <div className="sidebar_top">
        <img src={img} alt="" />
        {/* <Avatar
          sx={{ width: 80, height: 80 }}
          src={}
          className="sidebar_avatar" >
          {"Profile"}
        </Avatar> */}
        <AccountCircleIcon style={{ width: 80, height: 80 }} />
        <h2>{userInfo?.firstname} {userInfo?.lastname}</h2>
        <p>{userInfo?.email}</p>
        <p>{userInfo?.role}</p>
      </div>
      <div className="sidebar_stats">
        <div className="sidebar_stat">
          <p>
            OFFERED <br />
          </p>
          <p className="sidebar_statNumber">{offered}</p>
        </div>
        <div className="sidebar_stat">
          <p>OFFER ACCEPTED</p>
          <p className="sidebar_statNumber">{hired}</p>
        </div>
      </div>

      <div className="sidebar_stats_3">
        <h4>
          <BookmarkIcon />
          {date}
        </h4>
      </div>
      <div className="sidebar_bottom">
        <p>Applicants</p>
        {ApplicantLink?.map((data: any, i: any) => (
          <div className="sidebar_recentItem" key={i}>
            <div className="sidebar_hash_container">
              <div className="sidebar_hash_container1">
                <span className="sidebar_hash">#</span>
                <Link to="/applicants" state={{ data: data?.link }} >
                  <p>{data?.Active}</p>
                </Link>
              </div>
              <p>{data?.suffix}</p>
            </div>

          </div>))}
      </div>
    </div>
  );
}

export default SideBar;


